import { Event, events } from "@planzone/events";

function useCleanUp() {
  return (done?: () => void) => (event: Event) => {
    if (event.type === events.createKanbanTaskSucceeded) {
      done && done();
    }
  };
}

export { useCleanUp };
